import React, { useState, useEffect } from 'react';
import DashboardLayout from '../Dashboard/layout';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';  // Ensure axios is imported
import Swal from 'sweetalert2';
import "./InterestsPage.css";
import { ADDBTN, Headings, SerchInput, UserSelect } from '../RegisteredUsersList/ViewRegList';
import { FaAngleDoubleLeft , FaAngleDoubleRight } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import { FiEdit } from "react-icons/fi";

const ViewInterestsPageList = () => {
  const [interests, setInterests] = useState([]);
  const [filteredInterests, setFilteredInterests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedStatus, setSelectedStatus] = useState('');
  const [searchQuery, setSearchQuery] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [interestsPerPage] = useState(5); 
  const navigate = useNavigate();

  useEffect(() => {
    const fetchInterests = async () => {
      setLoading(true);
      try {
        const response = await axios.get(`${process.env.REACT_APP_BASE_URL}api/admin/interests`);
        //console.log(response, "there");
        if (response.data && response.data.interests && response.data.interests.length > 0) {
          setInterests(response.data.interests);
          setFilteredInterests(response.data.interests);
        } else {
          //Swal.fire('No Data Available', 'There are no interests available at the moment.', 'info');
        }
      } catch (error) {
        console.error('Failed to fetch interests:', error);
        Swal.fire('Error', 'Failed to load interests. Please try again later.', 'error');
      } finally {
        setLoading(false);
      }
    };

    fetchInterests();
  }, []);

  useEffect(() => {
    let filtered = interests;

    if (selectedStatus) {
      filtered = filtered.filter((interest) => interest.status === parseInt(selectedStatus)); 
    }

    if (searchQuery) {
      filtered = filtered.filter(
        (interest) =>
          interest.name.toLowerCase().includes(searchQuery.toLowerCase())
      );

    }

    setFilteredInterests(filtered);
    setCurrentPage(1); 
  }, [selectedStatus, searchQuery, interests]);

  // Delete an interest
  const handleDeleteInterests = (interestId) => {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this interest!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!',
    }).then((result) => {
      if (result.isConfirmed) {
        // Make a delete API request
        axios
          .delete(`${process.env.REACT_APP_BASE_URL}api/admin/interests/${interestId}`)
          .then(() => {
            setInterests(interests.filter((interest) => interest._id !== interestId));
            setFilteredInterests(filteredInterests.filter((interest) => interest._id !== interestId));
            Swal.fire('Deleted!', 'The interest has been deleted.', 'success');
          })
          .catch((error) => {
            console.error('Error deleting interest:', error);
            Swal.fire('Error', 'There was an issue deleting this interest.', 'error');
          });
      }
    });
  };

  // Edit interest (redirect to edit page)
  const handleEditInterests = (interestId) => {
    navigate(`/edit-interests/${interestId}`); 
  };

  // Pagination logic
  const indexOfLastInterest =  (currentPage - 1) * interestsPerPage;
  //const indexOfFirstInterest = indexOfLastInterest - interestsPerPage;
  const currentInterests = filteredInterests.slice(indexOfLastInterest, indexOfLastInterest+interestsPerPage);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const totalPages = Math.ceil(filteredInterests.length / interestsPerPage);

  const handleAddInterestsClick = () => {
    navigate('/add-interests'); 
  };

  const statusOptions = [
    { value: '', label: 'All' },
    { value: '1', label: 'Active' },
    { value: '0', label: 'Inactive' },
  ];

  return (
    <>
      <DashboardLayout>

        <section className="MainDivSec">

          <Headings headspan="Interests" hedtext=" List" />

          <div className="TopSelctDiv">
            <div className="LeftSlct">
              <UserSelect slctvluename="Filter by Status:" selectedRole={selectedStatus} slctonchange={(e) => setSelectedStatus(e.target.value)} options={statusOptions} slcthtmlfor="statusFilter" />
            </div>
            <div className="RytSrch">
              <SerchInput searchvalue={searchQuery} searchonchange={(e) => setSearchQuery(e.target.value)} srchid="searchQuery" srchplcehldr="Search by name" />
              <ADDBTN adtext="Add Interests" adonclick={handleAddInterestsClick}/>
            </div>
          </div>

          <div className="TableSec">
          
            {loading ? (
              <p className="Loadingpara">Loading...</p>
            ) : (
            <>

            <div className="UserTableDiv">
              <table className="User_Table">
                <thead>
                  <tr>
                    <th>SR NO</th>
                    <th>Name</th>
                    <th>Status</th>
                    <th>Image</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                {currentInterests.length > 0 ? (
                currentInterests.map((interest,index) => (
                  <tr key={interest.id}>
                     <td>{indexOfLastInterest+index + 1}</td>
                    <td>{interest.name}</td>
                    <td>{interest.status === 1 ? 'Active' : 'Inactive'}</td>

                    <td>
                      <img 
                        src={interest?.icon} 
                        alt={interest.name} 
                        style={{ width: '50px', height: '50px', objectFit: 'cover' }} 
                      />
                    </td>
                    <td className='EditDelteDiv'>
                      <button onClick={() => handleEditInterests(interest._id)}><FiEdit /></button>
                      <button
                        className="delete-btn"
                        onClick={() => handleDeleteInterests(interest._id)}
                      >
                        <MdDelete />
                      </button>
                    </td>
                  </tr>
                ))
                ) : (
                  <tr>
                    <td colSpan="5">Interest not found.</td>
                  </tr>
                )}
              </tbody>
              </table>
            </div>

            <div className="Tablepagination">
                <button onClick={() => paginate(currentPage - 1)}
                  disabled={currentPage === 1} >
                  <FaAngleDoubleLeft/>
                </button>
                {[...Array(totalPages)].map((_, index) => (
                  <button
                    key={index + 1}
                    onClick={() => paginate(index + 1)}
                    className={currentPage === index + 1 ? "active" : ""}
                  >
                    {index + 1}
                  </button>
                ))}
                <button onClick={() => paginate(currentPage + 1)}
                  disabled={currentPage === totalPages}>
                  <FaAngleDoubleRight />
                </button>
            </div>

            </>
            )}
          </div>

        </section>


      </DashboardLayout>
    </>
  );
};

export default ViewInterestsPageList;
